import { Link } from 'react-router-dom';
import { ArrowLeft, GraduationCap, Presentation, ClipboardCheck, UserCheck, Building2, Anchor, BookOpenCheck } from 'lucide-react';

export const ROLES_PRO = [
  { value: 'formateur', label: 'Formateur', Icone: Presentation, desc: "Vous enseignez ou encadrez des séances pour FISL. Vous n'êtes pas en formation." },
  { value: 'evaluateur', label: 'Évaluateur', Icone: ClipboardCheck, desc: 'Vous faites passer les épreuves de certification (jury).' },
  { value: 'tuteur', label: 'Tuteur', Icone: UserCheck, desc: 'Vous accompagnez un stagiaire FISL dans votre structure pendant son stage.' },
  { value: 'entreprise', label: "Entreprise d'accueil", Icone: Building2, desc: 'Votre structure accueille des stagiaires FISL ou recrute des moniteurs.' },
  { value: 'moniteur_vnm', label: 'Moniteur VNM (FISL)', Icone: Anchor, desc: 'Vous êtes diplômé(e) FISL : accédez aux annonces et au réseau des moniteurs.' },
  { value: 'responsable_pedagogique', label: 'Responsable pédagogique', Icone: BookOpenCheck, desc: "Vous coordonnez les formations et le suivi pédagogique d'un centre FISL." },
];

export const ChoixRolePro = ({ onChoix, onRetour }) => (
  <div className="space-y-4" data-testid="choix-role-pro">
    <button type="button" onClick={onRetour} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A]" data-testid="retour-accueil">
      <ArrowLeft className="h-4 w-4" /> Retour
    </button>
    <div>
      <h2 className="text-lg md:text-xl font-display font-bold text-[#0F172A]">Je travaille avec FISL</h2>
      <p className="text-sm text-slate-500">Choisissez votre rôle :</p>
    </div>

    <div className="grid sm:grid-cols-2 gap-3">
      {ROLES_PRO.map(({ value, label, Icone, desc }, i) => (
        <button
          key={value}
          type="button"
          onClick={() => onChoix(value)}
          style={{ animationDelay: `${i * 40}ms` }}
          className="group rounded-xl border-2 border-slate-200 bg-white p-4 text-left transition-colors duration-200 hover:border-[#8DC63F] hover:bg-[#8DC63F]/5 animate-in fade-in slide-in-from-bottom-1 fill-mode-both"
          data-testid={`role-card-${value}`}
        >
          <div className="flex items-center gap-2">
            <Icone className="h-5 w-5 text-[#8DC63F] shrink-0" />
            <span className="font-semibold text-[#0F172A]">{label}</span>
          </div>
          <p className="mt-1.5 text-xs leading-relaxed text-slate-500">{desc}</p>
        </button>
      ))}
    </div>

    <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-3" data-testid="garde-fou-candidat">
      <GraduationCap className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
      <p className="text-sm text-amber-800">
        Vous souhaitez <strong>suivre une formation</strong> ? Ce n'est pas ici :{' '}
        <Link to="/inscription-candidat" className="font-semibold underline" data-testid="garde-fou-candidat-link">inscrivez-vous comme candidat</Link>.
      </p>
    </div>
  </div>
);
